import { useLocation } from '@reach/router';
import Cookies from 'js-cookie';
import { browserDocument, browserWindow } from 'utils/window';

export const getSiteURL = () => {
  return process.env.SITE_URL || 'https://hometap.com';
};

export const isProduction = () => {
  return !process.env.SITE_URL?.includes('veranda') && !process.env.SITE_URL?.includes('localhost');
};

export const toQueryString = (object = {}) => {
  const params = new URLSearchParams();
  Object.keys(object).forEach((key) => {
    if (typeof object[key] === 'object') {
      params.set(key, JSON.stringify(object[key]));
    } else {
      params.set(key, object[key]);
    }
  });
  return params.toString();
};

export const fromQueryString = (string) => {
  const params = new URLSearchParams(string);
  const data = {};

  params.forEach((value, key) => {
    try {
      data[key] = JSON.parse(value);
    } catch (e) {
      data[key] = value;
    }
  });

  return data;
};

export const getUTMData = (utmParam) => {
  const oldCookieData = Cookies.getJSON('ht_utm_data');
  const utmUrl = new URL(browserWindow.location.href).searchParams;

  if (oldCookieData) {
    return utmUrl.get(utmParam) === null ? oldCookieData[utmParam] : utmUrl.get(utmParam);
  } else {
    return utmUrl.get(utmParam) === null ? undefined : utmUrl.get(utmParam);
  }
};

export const useQueryParams = () => {
  const location = useLocation();
  const params = location ? fromQueryString(location.search) : {};
  return params;
};

/* 
  The below method is used to set the referrer and referring_domain in ht_utm_data cookie for portals to access. 
  
  So the method follows the below logic,
  first checks if the referrer and referring_domain is present in the url params 
  if document referrer doesn't exist checks for referrer and referring_domain in old cookie data if that exists
  if both the above conditions are false we set the referrer and referring_domain details from document
  
  TODO(Nishanth): Clean up the logic
*/
export const getReferrerData = () => {
  const oldCookieData = Cookies.getJSON('ht_utm_data');
  const utmUrl = new URL(browserWindow.location.href).searchParams;
  const referrer = browserDocument.referrer === '' ? undefined : browserDocument.referrer;
  let referrerData = {};

  if (oldCookieData) {
    if (utmUrl.get('referrer')) {
      referrerData.referrer = utmUrl.get('referrer');
      referrerData.referringDomain =
        utmUrl.get('referring_domain') === null
          ? utmUrl.get('referrer')?.split('/')[2]
          : utmUrl.get('referring_domain');
      return referrerData;
    } else if (oldCookieData['referrer'] !== null && browserDocument.referrer === '') {
      referrerData.referrer = oldCookieData['referrer'];
      referrerData.referringDomain =
        oldCookieData['referring_domain'] === null
          ? oldCookieData['referrer']?.split('/')[2]
          : oldCookieData['referring_domain'];
      return referrerData;
    } else {
      referrerData.referrer = referrer;
      referrerData.referringDomain = browserDocument.referrer?.split('/')[2];
      return referrerData;
    }
  } else {
    referrerData.referrer = referrer;
    referrerData.referringDomain = browserDocument.referrer?.split('/')[2];
    return referrerData;
  }
};

export const setUserPropertiesForPortals = (data) => {
  const { marketing_site_user_properties, ...others } = Cookies.getJSON('ht_utm_data');
  const parsedSiteUserProperties =
    typeof marketing_site_user_properties === 'string'
      ? JSON.parse(marketing_site_user_properties)
      : marketing_site_user_properties;
  const siteUserProperties = { ...parsedSiteUserProperties, ...data };

  Cookies.set(
    'ht_utm_data',
    {
      ...others,
      marketing_site_user_properties: JSON.stringify(siteUserProperties),
    },
    {
      expires: 365,
      domain: browserWindow.location.hostname === 'www.hometap.com' ? '.hometap.com' : browserWindow.location.hostname,
    },
  );
};
